import React from 'react'
import PropTypes from 'prop-types'
import styles from './PagesList.scss'
import { Link } from 'react-router-dom'
import CreatePageModal from '../../components/CreatePageModal'
import Pagination from '../../components/Pagination'
import PagesTable from '../../components/PagesTable'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'

const PagesList = props =>
  <div className={styles.PagesList}>
    <div>
      <Breadcrumb>
        <BreadcrumbItem><Link to='/'>Home</Link></BreadcrumbItem>
        <BreadcrumbItem active>Pages</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <CreatePageModal />
    <PagesTable
      onSorts={props.onSorts}
      sortBy={props.sortBy}
      sortDirection={props.sortDirection}
      pages={props.rows} />
    <Pagination
      total={props.total}
      limit={props.limit}
      history={props.history}
      match={props.match} />

  </div>

PagesList.propTypes = {
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  onSorts: PropTypes.object,
  total: PropTypes.number,
  limit: PropTypes.number,
  history: PropTypes.object,
  match: PropTypes.object,
  rows: PropTypes.array
}

export default PagesList



// WEBPACK FOOTER //
// ./src/pages/PagesList/PagesList.js